import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/BedTagsBalanceReport/SearchReport",
    method: "POST",
    params
  });
}
